const routes = {
  auth: {
    login: "/auth/login",
    createAccount: "/auth/create-account",
    checkEmail: "/auth/check-email",
    signIn: "/auth/sign-in",
    cartedo: "/auth/cartedo",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    createPassword: "/auth/create-password",
  },
  mentor: '/mentor',
  cartedoCertificate: "/cartedo-certificate",
  digitalCV: "/digital-cv",
  bizProfile: "/biz-profile",
  bizAdmin: "/biz-admin",
  dashboard: "/dashboard",
  marketplace: "/marketplace",
  opportunities: {
    view: "/opportunities",
    viewMore: "opportunities/view-more"
  },
  surveys: {
    view: "/surveys",
    viewMore: "/surveys/view-more",
    viewAnswers: "/surveys/view-answers"
  },
  courses: {
    view: "/courses",
    viewMore: "/courses/view-more",
    viewAnswers: "/courses/view-answers"
  },
  redirects: {
    notFound: "/not-found",
  },
  settings: "/settings",
};

export default routes;
